<template>
  <v-app id="app">
    <router-view />

    <template v-if="envMode && ['dev', 'staging'].includes(envMode)">
      <div id="envWarn">
        Coach <span class="text-capitalize">{{ envMode }}</span>
      </div>
    </template>

    <!-- Global GHL Polling Progress Snackbar -->
    <v-snackbar
      :value="isGHLPolling"
      :timeout="-1"
      bottom
      right
      color="primary"
      elevation="6"
      min-width="450"
      max-width="600"
      class="global-ghl-snackbar"
    >
      <div class="d-flex flex-column">
        <div class="d-flex align-center mb-2">
          <v-progress-circular
            :value="ghlPolling.progress"
            :size="32"
            :width="3"
            color="white"
            class="mr-3"
          >
            <span class="text-caption white--text">{{ Math.round(ghlPolling.progress) }}%</span>
          </v-progress-circular>
          <div class="flex-grow-1">
            <div class="text-subtitle-2 white--text font-weight-medium">
              eLearning Connection
            </div>
            <div class="text-caption white--text">
              {{ ghlPolling.statusMessage }}
            </div>
          </div>
          <v-btn
            icon
            small
            color="white"
            @click="cancelGHLPolling"
          >
            <v-icon small>
              mdi-close
            </v-icon>
          </v-btn>
        </div>
        <v-progress-linear
          :value="ghlPolling.progress"
          color="white"
          background-color="rgba(255,255,255,0.3)"
          height="4"
          rounded
          class="mb-2"
        />
        <div class="d-flex justify-space-between text-caption white--text">
          <span>
            {{ formatTime(ghlPolling.elapsedTime) }} / {{ formatTime(ghlPolling.maxTimeout) }}
          </span>
          <span>Poll: {{ ghlPolling.pollCount }}</span>
        </div>
      </div>
    </v-snackbar>
  </v-app>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'App',

  data: () => ({}),

  computed: {
    ...mapState({
      ghlPolling: (state) => state.ghlPolling,
    }),

    isGHLPolling() {
      const polling = this.ghlPolling?.isPolling || false;
      return polling;
    },

    envMode() {
      return process.env.VUE_APP_ENV || null;
    },
  },

  // watch: {
  //   'ghlPolling.isPolling': {
  //     handler(newVal, oldVal) {
  //       console.log('[App.vue Watch] ghlPolling.isPolling changed from', oldVal, 'to', newVal);
  //       console.log('[App.vue Watch] Current GHL State:', this.ghlPolling);
  //     },
  //     immediate: true,
  //   },
  //   isGHLPolling: {
  //     handler(newVal, oldVal) {
  //       console.log('[App.vue Watch] isGHLPolling computed changed from', oldVal, 'to', newVal);
  //     },
  //     immediate: true,
  //   },
  // },

  methods: {
    cancelGHLPolling() {
      this.$polling.stopPolling('ghl-request');
      this.$toast.info('eLearning request cancelled');
      this.$store.dispatch('ghlPolling/stopPolling');
    },

    formatTime(milliseconds) {
      const totalSeconds = Math.floor(milliseconds / 1000);
      const minutes = Math.floor(totalSeconds / 60);
      const seconds = totalSeconds % 60;
      return `${minutes}:${seconds.toString().padStart(2, '0')}`;
    },
  },
};
</script>

<style>
  * {
    word-break: break-word !important;
  }

  body {
    background-color: #121212;
  }

  #envWarn {
    position: fixed;
    top: 0;
    left: 50%;
    color: white;
    border-radius: 5px;
    z-index: 99999;
    padding: 5px 10px;
    font-weight: bold;
    margin-top: 13px;
    transform: translateX(-50%);
    animation: warning 2s ease-in-out infinite;
  }

  @keyframes warning {
    0% {background: red; box-shadow: 0 0 10px 5px rgba(255, 0, 0, 0.5);}
    25% {background: blue; box-shadow: 0 0 10px 5px rgba(100, 100, 255, 0.5);}
    100% {background: red; box-shadow: 0 0 10px 5px rgba(255, 50, 50, 0.7);}
  }

  /* Global GHL Polling Snackbar - Ensure highest z-index */
  .global-ghl-snackbar .v-snack__wrapper {
    z-index: 10000 !important;
    position: fixed !important;
    bottom: 95px !important;
  }

  .global-ghl-snackbar .v-snack__content {
    padding: 16px !important;
  }
</style>
